import { useCallback, useRef, useState } from "react";

export function useMeasure() {
	const [dimensions, setDimensions] = useState<{
		width: number | undefined;
		height: number | undefined;
	}>({
		width: undefined,
		height: undefined,
	});

	const previousObserver = useRef<ResizeObserver | undefined>(undefined);

	const customRef = useCallback<React.RefCallback<HTMLDivElement>>((node) => {
		if (previousObserver.current) {
			previousObserver.current.disconnect();
			previousObserver.current = undefined;
		}

		if (node?.nodeType === Node.ELEMENT_NODE) {
			const observer = new ResizeObserver(([entry]) => {
				if (entry && entry.borderBoxSize && entry.borderBoxSize[0]) {
					const { inlineSize: width, blockSize: height } =
						entry.borderBoxSize[0];

					setDimensions({ width, height });
				}
			});

			observer.observe(node);
			previousObserver.current = observer;
		}
	}, []);

	return [customRef, dimensions] as const;
}
